import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-gradient-to-br from-primary-900 via-primary-800 to-accent-900">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-white">{appInfo.title}</h2>
            <p className="text-accent-300 text-lg md:text-xl font-bold mt-2">{appInfo.subtitle}</p>
            <p className="text-white/70 text-sm md:text-base mt-4 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appInfo.description}
            </p>
            <ul className="flex flex-col gap-2 mt-5">
              {appInfo.features.map((feat, i) => (
                <li key={i} className="flex items-center gap-2 text-white/80 text-sm">
                  <i className="ri-checkbox-circle-fill text-accent-400 flex-shrink-0"></i>
                  {feat}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 hover:bg-accent-400 text-white font-bold text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-android-line text-lg"></i>
                安卓版下载安装包
              </a>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#faq');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/25 text-white font-medium text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-question-line text-lg"></i>
                安装帮助
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-48 md:w-56 lg:w-64">
            <div className="relative">
              <div className="absolute -inset-3 bg-accent-500/20 rounded-3xl blur-xl"></div>
              <img
                src={appInfo.image}
                alt="51吃瓜轻量版APP界面预览"
                className="relative w-full h-auto rounded-2xl"
                width="400"
                height="700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}